<template>

    <div >
<!--        <div class="d-flex">-->
<!--            <div class="depart-wrap-fl">-->
<!--                <img src="@imgPath/img/svg/icons/sun_rise.svg" alt="">-->
<!--                <input type="checkbox" id="1" class="d-none">-->
<!--                <label for="1">06:00 </br> 11:59</label>-->
<!--            </div>-->
<!--            <div class="depart-wrap-fl">-->
<!--                <img src="@imgPath/img/svg/icons/sun.svg" alt="">-->
<!--                <input type="checkbox" id="1" class="d-none">-->
<!--                <label for="1">12:00</br>-->
<!--                    17:59</label>-->
<!--            </div>-->
<!--            <div class="depart-wrap-fl">-->
<!--                <img src="@imgPath/img/svg/icons/sun_set.svg" alt="">-->
<!--                <input type="checkbox" id="1" class="d-none">-->
<!--                <label for="1">18:00</br>-->
<!--                    23:59</label>-->
<!--            </div>-->
<!--            <div class="depart-wrap-fl">-->
<!--                <img src="@imgPath/img/svg/icons/night_moon.svg" alt="">-->
<!--                <input type="checkbox" id="1" class="d-none">-->
<!--                <label for="1">00:00</br>-->
<!--                    05:59</label>-->
<!--            </div>-->
<!--        </div>-->

        <div class="d-flex">
            <label v-for="(depTime, index) in options" :key="index"
                 :class="depTime.status==1 && depTime.by=='user'?'depart-wrap-fl active' : 'depart-wrap-fl'" >

                <img v-if="index==0" src="@imgPath/img/svg/icons/sun_rise.svg" alt="">
                <img  v-if="index==1"  src="@imgPath/img/svg/icons/sun.svg" alt="">
                <img v-if="index==2" src="@imgPath/img/svg/icons/sun_set.svg" alt="">
                <img  v-if="index==3" src="@imgPath/img/svg/icons/night_moon.svg" alt="">
                <label :for="'ibDepTime'+index" >{{ depTime.start }} <br>{{depTime.end}}</label>

                <input :id="'ibDepTime'+index"
                       type="checkbox" :checked='depTime.status==1 && depTime.by=="user"'
                       
                       v-on:input="onEmitSelAL(depTime)" class="d-none"

                />
<!-- :disabled='(depTime.status==1 && depTime.by=="default") ||
                                (depTime.status==0 && depTime.by=="user")' -->

            </label>
        </div>






    </div>


</template>

<script>
    import router, {navigate, goBack} from "../../router/index";
    import {ValidationProvider} from "vee-validate";
    import Multiselect from "vue-multiselect";

    import {mapGetters, mapActions} from "vuex";
    import {PATHNAME, COMPONENT_NAME, FILTER} from "../../util/constants.js";
    import BaseConfiguration from "../../config/base.js";
    import {
        VALIDATE_SUCCESS_RES,
        getErrorMessage
    } from "../../util/apiValidate.js";
    import {handleJWT, getErrorAlertValue} from "../../util/util";
    import SERVICE_URL from "../../config/API_DATA";
    import Logger from "../../services/logger";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";

    export default {
        name: COMPONENT_NAME.C_FILTER_TIME_IB,
        components: {
            ValidationProvider,
            Multiselect
        },
        model: {
            prop: "selValue"
        },
        props: {

            filterIbWatList: {
                type: Object
            }

        },
        data: () => ({
            options: [],
            selectedDepTime: [],
            selValueModel: [],
            selALNameLs: [],
            filterIbWatchList: {},
        }),

        watch: {
            selValue(val) {
                if (val !== this.selValueModel) {
                    this.selValueModel = val;
                }
            },
            filterIbWatList: {
                immediate: false,
                deep: true,
                handler: function (newVal, oldVal) {

                    if (oldVal == newVal || oldVal != newVal) {
                        this.filterIbWatchList = this.filterIbWatList;
                        this.selValueModel = this.filterIbWatchList[FILTER.C_FILTER_DEPTIME];

                        this.options = this.filterIbWatchList[FILTER.C_FILTER_DEPTIME];


                    }

                }
            },


        },

        async created() {


            try {
                if (BaseConfiguration.isDebug) console.log(" created");
                this.filterIbWatchList = this.filterIbWatList;
                if (BaseConfiguration.isDebug) console.log(this.filterIbWatList);
                this.selValueModel = this.filterIbWatchList[FILTER.C_FILTER_DEPTIME];
                this.options = this.filterIbWatchList[FILTER.C_FILTER_DEPTIME];


                if (this.selValueModel.length > 0) {
                    for (let i = 0; i < this.selValueModel.length; i++) {
                        this.selALNameLs.push(this.selValueModel[i].name);
                        this.selectedDepTime.push(this.selValueModel[i]);

                    }

                }


               if (BaseConfiguration.isDebug) console.log(this.selValueModel)
            } catch (err) {
                let body = Logger.buildRequest(
                    COMPONENT_NAME.C_FILTER_DEPTIME,
                    "error while Component created",
                    err.toString(),
                    "created",
                    LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
            }

        },

        computed: {},

        methods: {
            onEmitSelAL(pselValueModel) {
                let retValue;

                try {
                    for (let i = 0; i < this.selectedDepTime.length; i++) {
                        if (this.selectedDepTime[i].start == pselValueModel.start) {
                            if(this.selectedDepTime[i].by=='default' && this.selectedDepTime[i].status==1) {
                                this.selectedDepTime[i].by='user';
                                this.selectedDepTime[i].status=1
                            }else{
                            this.selectedDepTime[i].by == 'user' ? this.selectedDepTime[i].by = 'default' : this.selectedDepTime[i].by = 'user';
                            this.selectedDepTime[i].status == 0 ? this.selectedDepTime[i].status = 1 :
                                this.selectedDepTime[i].status = 0;
                        }
                        }
                    }


                    this.$emit('input', this.selectedDepTime, FILTER.C_FILTER_DEPTIME);

                } catch (err) {
                    let body = Logger.buildRequest(
                        COMPONENT_NAME.C_FILTER_DEPTIME,
                        "error while onEmitSelAL",
                        err.toString(),
                        "onEmitSelAL",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },


        },

    };
</script>
<style scoped>
    .noDepTime {
        background-color: rgb(255, 254, 254);
    }
</style>

